import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';


class FormVen18  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaDesde: null,
            fechaHasta: null,
            cliente_sel: null,
            vendedor_sel: null            
        };

        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.impProformasAnuladas = this.impProformasAnuladas.bind(this);
    }

    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0418');
        let fechaProceso = getFechaProcesoPorModulo('04');
        let fechaHasta = moment(fechaProceso, 'DD/MM/YYYY');

        this.setState({
            fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
            fechaDesde: moment(fechaHasta.subtract(30, 'days'))
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0418');
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    getOptions_Clientes(input, callback){        
        if (input.toString().length >= 2 ){
            let query = "?cadena_busq=" + input;     
            cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    getOptions_Vendedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/vendedores', cadena_busq, callback)              
        }
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('04');
        let fechaHasta = moment(fechaProceso, 'DD/MM/YYYY');

        this.setState({
            fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
            fechaDesde: moment(fechaHasta.subtract(30, 'days')),
            cliente_sel: null,
            vendedor_sel: null    
        });
    }

    impProformasAnuladas(){
        try{

            let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
            if (!validarFechaMomentEnFormatoString(fechaDesde)){
                alert('La fecha Desde es inválida.');
                return;
            }
            
            let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
            if (!validarFechaMomentEnFormatoString(fechaHasta)){
                alert('La fecha Hasta es inválida.');
                return;
            }

            if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){        
                alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
                return;
            }

            let urlReportWithParams=`&rpt=73`;

            urlReportWithParams+=`&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}`;
            urlReportWithParams+=`&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;

            if(this.state.cliente_sel){
                urlReportWithParams+=`&param3=${this.state.cliente_sel.value}`;
            }
            if(this.state.vendedor_sel){
                urlReportWithParams+=`&param4=${this.state.zona.vendedor_sel.value}`;
            }

            visualizarReporteEnPdf(urlReportWithParams);
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
                <HeaderForm>
                    <TituloForm>Proformas anuladas</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>F. Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fecha)=>{this.setState({fechaDesde: fecha});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>F. Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fecha)=>{this.setState({fechaHasta: fecha});}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Cliente:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} 
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({cliente_sel: value});}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Vendedor:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.vendedor_sel} func_loadOptions={this.getOptions_Vendedores} 
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({vendedor_sel: value});}}/>
                        </ContainerCol>
                    </Row>                    
                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.impProformasAnuladas}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (null, mapDispatchToProps)(FormVen18);